"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceInputState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var input_state_1 = require("./input.state");
var number_input_state_1 = require("./number.input.state");
var DistanceInputState = /** @class */ (function (_super) {
    tslib_1.__extends(DistanceInputState, _super);
    function DistanceInputState(label) {
        var _this = _super.call(this, label) || this;
        _this.isLabelShown = false;
        var debounceMetric = (0, lodash_1.debounce)(function () { return _this.updateMetric(); }, 600);
        var debounceImperial = (0, lodash_1.debounce)(function () { return _this.updateImperial(); }, 600);
        var metricOptions = {
            onblur: function () { return debounceMetric.flush(); },
            oninput: function () { return debounceMetric(); }
        };
        var imperialOptions = {
            onblur: function () { return debounceImperial.flush(); },
            oninput: function () { return debounceImperial(); }
        };
        _this.meters = new number_input_state_1.NumberInputState('m', DistanceInputState.METER_PRECISION, undefined, metricOptions);
        _this.feet = new number_input_state_1.NumberInputState('ft', undefined, undefined, imperialOptions);
        _this.inch = new number_input_state_1.NumberInputState('in', DistanceInputState.INCH_PRECISION, undefined, imperialOptions);
        _this.meters.isLabelShown = false;
        _this.feet.isLabelShown = false;
        _this.inch.isLabelShown = false;
        _this.meters.hideZero = true;
        _this.feet.hideZero = true;
        _this.inch.hideZero = true;
        return _this;
    }
    DistanceInputState.equal = function (value1, value2) {
        var inches1 = DistanceInputState.metersAsInches(value1);
        var inches2 = DistanceInputState.metersAsInches(value2);
        return number_input_state_1.NumberInputState.equal(inches1, inches2, DistanceInputState.INCH_PRECISION);
    };
    DistanceInputState.metersAsInches = function (value) {
        return core_shared_1.IkeUnit.round(core_shared_1.IkeUnit.convert(value, core_shared_1.IkeUnit.INCH, core_shared_1.IkeUnit.METER), number_input_state_1.NumberInputState.DEFAULT_PRECISION);
    };
    DistanceInputState.prototype.setValue = function (meters) {
        this._value = meters;
        if (this.value == null || isNaN(this.value)) {
            this.meters.setValue(null);
            this.feet.setValue(null);
            this.inch.setValue(null);
            return;
        }
        var inches = DistanceInputState.metersAsInches(this.value);
        var feetInch = core_shared_1.IkeUnit.splitFeetInch(inches);
        if (feetInch.feet !== this.feet.value) {
            this.feet.setValue(feetInch.feet !== 0 ? feetInch.feet : null);
        }
        if (feetInch.inches !== this.inch.value) {
            this.inch.setValue(feetInch.inches !== 0 ? feetInch.inches : null);
        }
        this.meters.setValue(this.value !== 0 ? this.value : null);
    };
    DistanceInputState.prototype.hasError = function () {
        return this.meters.hasError() || this.feet.hasError() || this.inch.hasError();
    };
    DistanceInputState.prototype.updateImperial = function () {
        if (this.hasError()) {
            return;
        }
        if (this.feet.value == null && this.inch.value == null) {
            this.setValue(null);
        }
        else {
            var inches = core_shared_1.IkeUnit.joinFeetInch(this.feet.value || 0, this.inch.value || 0);
            var meters = core_shared_1.IkeUnit.convert(inches, core_shared_1.IkeUnit.METER, core_shared_1.IkeUnit.INCH);
            this.setValue(meters);
        }
    };
    DistanceInputState.prototype.updateMetric = function () {
        if (this.hasError()) {
            return;
        }
        this.setValue(this.meters.value);
    };
    Object.defineProperty(DistanceInputState.prototype, "isAutoFocused", {
        get: function () {
            return this.meters.isAutoFocused;
        },
        set: function (isFocus) {
            if (this.feet == null) {
                return;
            }
            this.meters.isAutoFocused = isFocus;
            this.feet.isAutoFocused = isFocus;
        },
        enumerable: false,
        configurable: true
    });
    DistanceInputState.METER_PRECISION = 3;
    DistanceInputState.INCH_PRECISION = 1;
    tslib_1.__decorate([
        mobx_1.action
    ], DistanceInputState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], DistanceInputState.prototype, "updateImperial", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], DistanceInputState.prototype, "updateMetric", null);
    return DistanceInputState;
}(input_state_1.InputState));
exports.DistanceInputState = DistanceInputState;
//# sourceMappingURL=distance.input.state.js.map